import React from 'react'
import './NotFoundComponent.scss'
import Layout from '../../../layouts/Layout'
import { Header } from 'semantic-ui-react'

const NotFoundComponent = () => {
    return (
      <Layout>
        <Header as='h1'>Page not found</Header>
      </Layout>
    )
}

export default NotFoundComponent




// WEBPACK FOOTER //
// ./src/components/NotFoundComponent/components/NotFoundComponent.js